<template>
  <div v-loading="showFlag">
    <!--  運送製品選択画面 -->
    <t-card>
      <div :style="{ height: basicHeight + 'px' }">
        <t-form
          :model="searchConditionForm"
          label-position="right"
          label-width="100px"
        >
          <t-row class="col_common_center">
            <!-- 仕入先 -->
            <t-col :span="6">
              <t-form-item
                :label="$t('resource.TRANSPORT.SUPPLIER_COMPANY')"
                class="marginBottom"
              >
                <t-select
                  v-model="searchConditionForm.searchCrbSupCode"
                  placeholder=""
                  class="commonDialog"
                  clearable
                >
                  <t-option
                    v-for="item in supplierCpyList"
                    :key="item.supCode"
                    :label="item.supCode + ':' + item.supAbbreviation"
                    :value="item.supCode"
                  >
                  </t-option>
                </t-select>
              </t-form-item>
            </t-col>

            <!-- 輸送方式 -->
            <t-col :span="6">
              <t-form-item
                :label="$t('resource.TRANSPORT.TRANSPORT_METHOD')"
                class="marginBottom"
              >
                <t-select
                  placeholder=""
                  class="commonDialog"
                  v-model="searchConditionForm.searchTransMethod"
                >
                  <t-option
                    v-for="item in transMethodList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </t-option>
                </t-select>
              </t-form-item>
            </t-col>

            <!-- 入荷日 -->
            <t-col :span="11">
              <t-form-item
                :label="$t('resource.TRANSPORT.RECEIVE_DATE')"
                class="marginBottom"
              >
                <t-date-picker
                  v-model="dateRange"
                  type="daterange"
                  range-separator="～"
                  start-placeholder="開始日"
                  end-placeholder="終了日"
                  value-format="yyyy/MM/dd"
                  format="yyyy/MM/dd"
                  style="margin-top: 3px"
                  :clearable="true"
                  :editable="false"
                  class="date_icon_center"
                >
                </t-date-picker>
              </t-form-item>
            </t-col>
            <!--DEL 2025/03/10 ZLL 課題_運送製品選択画面_検索条件と一覧列の追加 start↓ -->
            <!-- <t-col
              :span="parseInt($t('widgetSize.COMMON_CONSTANT.SPAN_FOUR'))"
              class="right"
            > -->
            <!-- 検索 -->
            <!-- <t-button
                round
                type="primary"
                class="dialogButton_120_40"
                ref="searchBtn"
                @click="searchClick()"
              >
                <i class="el-icon-search"></i>
                {{ $t("resource.sys.search") }}
              </t-button>
            </t-col>-->
            <!--DEL 2025/03/10 ZLL 課題_運送製品選択画面_検索条件と一覧列の追加 end↑ -->
          </t-row>

          <!-- ADD 2025/03/10 ZLL 課題_運送製品選択画面_検索条件と一覧列の追加 start↓ -->
          <t-row>
            <!-- 得意先納期 -->
            <t-col :span="11">
              <t-form-item
                :label="$t('resource.TRANSPORT.CUSTOMER_DELIVERY_DATE')"
                label-width="125px"
                class="marginBottom"
              >
                <t-date-picker
                  v-model="cusDateRange"
                  type="daterange"
                  range-separator="～"
                  start-placeholder="開始日"
                  end-placeholder="終了日"
                  value-format="yyyy/MM/dd"
                  format="yyyy/MM/dd"
                  style="margin-top: 3px"
                  :editable="false"
                  clearable
                  class="date_icon_center"
                >
                </t-date-picker>
              </t-form-item>
            </t-col>
            <t-col :span="9"> &nbsp;</t-col>
            <t-col
              :span="parseInt($t('widgetSize.COMMON_CONSTANT.SPAN_FOUR'))"
              class="right"
            >
              <!-- 検索 -->
              <t-button
                round
                type="primary"
                class="dialogButton_120_40"
                ref="searchBtn"
                @click="searchClick()"
              >
                <i class="el-icon-search"></i>
                {{ $t("resource.sys.search") }}
              </t-button>
            </t-col>
          </t-row>
          <!-- ADD 2025/03/10 ZLL 課題_運送製品選択画面_検索条件と一覧列の追加 end↑ -->
        </t-form>
      </div>

      <div>
        <t-row class="marginBottom">
          <t-col :span="24">
            <!-- テーブル -->
            <div>
              <t-table
                ref="transportProdForm"
                :data="transportProdForm"
                class="table_common"
                header-cell-class-name="bg-default"
                :height="detailHeight"
                :row-class-name="rowClassName"
                highlight-current-row
                border
                fit
              >
                <!-- 選択ボックス -->
                <t-table-column type="selection" class-name="cell_txt_center">
                </t-table-column>
                <!-- テーブルの列 -->
                <t-table-column
                  v-for="(column, index) in columns"
                  :key="index"
                  :type="column.type"
                  :prop="column.prop"
                  :label="column.label"
                  :min-width="column.width"
                  :align="column.align"
                  :header-align="column.headerAlign"
                  :class-name="column.class"
                  :show-overflow-tooltip="column.overflowTooltip"
                >
                </t-table-column>
              </t-table>
            </div>
          </t-col>
        </t-row>
      </div>
      <div :style="{ height: bottomHeight + 'px' }">
        <t-form label-position="right">
          <t-row type="flex" justify="end">
            <div>
              <t-col :span="parseInt($t('widgetSize.COMMON_CONSTANT.SPAN_ONE'))"
                >&nbsp;</t-col
              >
              <t-col
                :span="
                  parseInt($t('widgetSize.COMMON_CONSTANT.SPAN_TWENTY_TWO'))
                "
              >
                <t-button
                  round
                  type="warning"
                  class="dialogButton_confirm_120_40"
                  @click="ConfirmClick"
                >
                  <i class="el-icon-check"></i>
                  {{ $t("resource.sys.sure") }}</t-button
                >
              </t-col>
              <t-col :span="parseInt($t('widgetSize.COMMON_CONSTANT.SPAN_ONE'))"
                >&nbsp;</t-col
              >
            </div>
          </t-row>
        </t-form>
      </div>
    </t-card>
  </div>
</template>
<script>
import { getTransInitList, searchTransSelectInfo } from "@/services/transport";

import { t } from "@/locales";
import {
  formatCurDateToString,
  formatUndefinedToDate,
  getDialogContentHeight,
  getNextMonthDate,
  getPreviousMonthDate,
} from "@/utils/comFunction";
import { DIALOG_LINE_HEIGHT, NORMAL_PROD, STR_EMPTY } from "@/utils/const";
import { flexColumnWidth, setColumnWidth } from "@/utils/table";
import { Message, Modal } from "@tellus/component";
export default {
  data() {
    return {
      //検索条件
      dateRange: [],

      // ADD 2025/03/10 ZLL 課題_運送製品選択画面_検索条件と一覧列の追加 start↓
      //得意先納期
      cusDateRange: [],
      // ADD 2025/03/10 ZLL 課題_運送製品選択画面_検索条件と一覧列の追加 end↑

      searchConditionForm: {
        searchCrbSupCode: "", // 仕入先
        searchTransMethod: "", //輸送方式
        searchStartDate: "", // 日付(開始日)
        searchEndDate: "", // 日付(終了日)
        // ADD 2025/03/10 ZLL 課題_運送製品選択画面_検索条件と一覧列の追加 start↓
        searchStartCusDate: "", // 得意先納期日付(開始日)
        searchEndCusDate: "", // 得意先納期日付(終了日)
        // ADD 2025/03/10 ZLL 課題_運送製品選択画面_検索条件と一覧列の追加 end↑
      },

      //運送一覧選択情報
      transportProdForm: [],

      // 仕入先リストの取得
      supplierCpyList: [],
      // 輸送方式
      transMethodList: [],

      //仕入先見積依頼のテーブルの列
      columns: [
        {
          // 仕入先
          prop: "crbSupCode",
          label: t("resource.TRANSPORT.SUPPLIER_COMPANY"),
          width: t("widgetSize.TRANSPORT.TABLE_DEFAULT_COLUMN_WIDTH"),
          class: "cell_txt_left",
          overflowTooltip: true,
        },
        // 入荷日
        {
          prop: "crbReceDateOnly",
          label: t("resource.TRANSPORT.RECEIVE_DATE"),
          width: t("widgetSize.TRANSPORT.TABLE_DEFAULT_COLUMN_WIDTH"),
          class: "cell_txt_center",
          overflowTooltip: false,
        },
        // 仕入先納期
        {
          // UPD 2025/04/24 Wjx 課題_250328~250416顧客からの改善したい点への対応 start↓
          // 納期、注番の変更(見積単位⇒製品単位に変更)
          // prop: "obDueDateOnly",
          prop: "odDueDateOnly",
          // UPD 2025/04/24 Wjx 課題_250328~250416顧客からの改善したい点への対応 end↑
          label: t("resource.TRANSPORT.SUPPLIER_DUE_DATE"),
          width: t("widgetSize.TRANSPORT.TABLE_DEFAULT_COLUMN_WIDTH"),
          class: "cell_txt_center",
          overflowTooltip: false,
        },
        // ADD 2025/03/10 ZLL 課題_運送製品選択画面_検索条件と一覧列の追加 start↓
        // 得意先納期
        {
          prop: "cusDueDateOnly",
          label: t("resource.TRANSPORT.CUSTOMER_DELIVERY_DATE"),
          width: t("widgetSize.TRANSPORT.TABLE_DEFAULT_COLUMN_WIDTH"),
          class: "cell_txt_center",
          overflowTooltip: false,
        },
        // ADD 2025/03/10 ZLL 課題_運送製品選択画面_検索条件と一覧列の追加 end↑
        // 注文No
        {
          prop: "obOrderNoShow",
          label: t("resource.TRANSPORT.ORDER_NO"),
          width: t("widgetSize.TRANSPORT.TABLE_DEFAULT_COLUMN_WIDTH"),
          class: "cell_txt_left",
          overflowTooltip: true,
        },
        // 品名
        {
          prop: "aodProdName",
          label: t("resource.orderInfo.productName"),
          width: t("widgetSize.TRANSPORT.TABLE_DEFAULT_COLUMN_WIDTH"),
          class: "cell_txt_left",
          overflowTooltip: true,
        },
        // 図番
        {
          prop: "aodProdDrawNo",
          label: t("resource.orderInfo.pictureNo"),
          width: t("widgetSize.TRANSPORT.TABLE_DEFAULT_COLUMN_WIDTH"),
          class: "cell_txt_left",
          overflowTooltip: true,
        },
        // 入荷件数
        {
          prop: "tdTransQty",
          label: t("resource.TRANSPORT.CHECK_RECEIVE_QUANTITY"),
          width: t("widgetSize.TRANSPORT.TABLE_DEFAULT_COLUMN_WIDTH"),
          class: "cell_txt_right",
          overflowTooltip: false,
        },

        // 単位
        {
          prop: "aodProdUnit",
          label: t("resource.TRANSPORT.PRODUCT_UNIT"),
          width: t("widgetSize.TRANSPORT.TABLE_DEFAULT_COLUMN_WIDTH"),
          class: "cell_txt_center",
          overflowTooltip: false,
        },
      ],

      showFlag: false,

      // UPD 2025/03/10 ZLL 課題_運送製品選択画面_検索条件と一覧列の追加 start↓
      //基本情報のheight
      // basicHeight: DIALOG_LINE_HEIGHT * 1,
      //明細情報のheight 20:Tableと合計行の間隔調整用(Table的marginTop + bottom)
      // detailHeight: getDialogContentHeight(
      //   window.innerHeight,
      //   DIALOG_LINE_HEIGHT * 1,
      //   DIALOG_LINE_HEIGHT * 1,
      //   20
      // ),
      //明細情報のheight 20:Tableと合計行の間隔調整用(Table的marginTop + bottom)
      detailHeight: getDialogContentHeight(
        window.innerHeight,
        DIALOG_LINE_HEIGHT * 2,
        DIALOG_LINE_HEIGHT * 1,
        20
      ),
      basicHeight: DIALOG_LINE_HEIGHT * 2,
      // UPD 2025/03/10 ZLL 課題_運送製品選択画面_検索条件と一覧列の追加 end↑

      //合計情報のheight
      bottomHeight: DIALOG_LINE_HEIGHT * 1,

      // 読み込み回数
      numLoads: 1,

      // 比較用明細情報
      cmpDetailResult: "",
    };
  },

  props: {
    isAdd: {
      Type: Boolean,
      default: false,
    },
    tableData: {
      Type: Object,
      default: null,
    },
    tdTransNo: {
      Type: Object,
      default: null,
    },
    //運送製品選択画面の検索条件
    selectedSearchForm: {
      Type: Object,
      default: null,
    },
  },
  mounted() {
    // 初期化
    this.init();
    // 列幅に自動調整
    setColumnWidth(this.columns, this.transportProdForm);

    //テーブルの高さを監視する
    window.addEventListener("resize", this.handleResize);
  },

  methods: {
    //テーブルの高さを設定する
    handleResize() {
      // UPD 2025/03/10 ZLL 課題_運送製品選択画面_検索条件と一覧列の追加 start↓
      // this.detailHeight = getDialogContentHeight(
      //   window.innerHeight,
      //   DIALOG_LINE_HEIGHT * 1,
      //   DIALOG_LINE_HEIGHT * 1,
      //   20
      // );
      this.detailHeight = getDialogContentHeight(
        window.innerHeight,
        DIALOG_LINE_HEIGHT * 2,
        DIALOG_LINE_HEIGHT * 1,
        20
      );
      // UPD 2025/03/10 ZLL 課題_運送製品選択画面_検索条件と一覧列の追加 end↑
    },

    // 初期化
    init() {
      this.showFlag = true;
      ///基本情報のリスト取得（仕入先、担当者）
      getTransInitList()
        .then((res) => {
          //仕入先リスト
          this.supplierCpyList = res.supNameList;
          // 輸送方式
          this.transMethodList = res.transMethodList;

          //運送製品選択画面の検索条件が空しない場合
          if (
            !!this.selectedSearchForm &&
            this.selectedSearchForm != STR_EMPTY
          ) {
            this.searchConditionForm = [];
            this.searchConditionForm = this.selectedSearchForm;
            if (this.searchConditionForm.searchStartDate == STR_EMPTY) {
              this.dateRange = [];
            } else {
              this.dateRange = [
                this.searchConditionForm.searchStartDate,
                this.searchConditionForm.searchEndDate,
              ];
            }

            // ADD 2025/03/10 ZLL 課題_運送製品選択画面_検索条件と一覧列の追加 start↓
            // 得意先納期日付の開始日が空の場合
            if (this.searchConditionForm.searchStartCusDate == STR_EMPTY) {
              this.cusDateRange = [];
            } else {
              this.cusDateRange = [
                this.searchConditionForm.searchStartCusDate,
                this.searchConditionForm.searchEndCusDate,
              ];
            }
            // ADD 2025/03/10 ZLL 課題_運送製品選択画面_検索条件と一覧列の追加 end↑
          } else {
            //日付初期化
            this.dateInit();
            this.searchConditionForm.searchTransMethod =
              this.transMethodList[0]?.value;
          }

          this.searchClick();
        })
        .catch((err) => {
          if (err.data != null) {
            Message.showError(
              t("message.COMMON_MESSAGE." + err.data.Messages[0].Message)
            );
          } else {
            Message.showError(t("message.COMMON_MESSAGE.SEARCH_FAILURE"));
          }
          this.showFlag = false;
        });
    },

    //日付初期化
    dateInit() {
      //システム日付
      var systemDate = new Date();
      //日付初期値の設定
      this.dateRange = [getPreviousMonthDate(systemDate), systemDate];

      // ADD 2025/03/10 ZLL 課題_運送製品選択画面_検索条件と一覧列の追加 start↓
      //日付初期値の設定
      this.cusDateRange = [systemDate, getNextMonthDate(systemDate)];
      // ADD 2025/03/10 ZLL 課題_運送製品選択画面_検索条件と一覧列の追加 end↑

      if (!!this.tableData) {
        //運送明細テーブル入荷日
        for (let index = 0; index < this.tableData.length; index++) {
          const element = this.tableData[index];

          var crbReceDateOnly = formatUndefinedToDate(element.crbReceDateOnly);

          if (crbReceDateOnly > this.dateRange[1]) {
            this.dateRange[1] = crbReceDateOnly;
          }
          if (crbReceDateOnly < this.dateRange[0]) {
            this.dateRange[0] = crbReceDateOnly;
          }

          // ADD 2025/03/10 ZLL 課題_運送製品選択画面_検索条件と一覧列の追加 start↓
          var cusDueDateOnly = formatUndefinedToDate(element.cusDueDateOnly);
          if (cusDueDateOnly > this.cusDateRange[1]) {
            this.cusDateRange[1] = cusDueDateOnly;
          }
          if (cusDueDateOnly < this.cusDateRange[0]) {
            this.cusDateRange[0] = cusDueDateOnly;
          }

          // ADD 2025/03/10 ZLL 課題_運送製品選択画面_検索条件と一覧列の追加 end↑
        }
      }
    },

    // 検索
    searchClick() {
      // フォーカス削除
      this.$refs.searchBtn.$el.blur();
      if (!this.showFlag) {
        this.showFlag = true;
      }

      // 検索条件の処理
      this.updateSearchForm();

      searchTransSelectInfo({
        transSelectInfo: this.searchConditionForm,
        tdTransNo: this.tdTransNo,
      })
        .then((res) => {
          if (res) {
            this.transportProdForm = res.transDetailInfoList;

            this.checkedProcess();

            // 読み込み回数 = 1
            if (this.numLoads == 1) {
              let data = this.$refs.transportProdForm.selection;

              // 比較用明細情報
              // this.cmpDetailResult = JSON.stringify(data.sort);

              // 読み込み回数 + 1
              this.numLoads = this.numLoads + 1;
            }

            Message.showSuccess(t("message.COMMON_MESSAGE.SEARCH_SUCCESS"));
            // データ処理
            // 列幅に自動調整
            setColumnWidth(this.columns, this.transportProdForm);
          }
        })
        .catch((err) => {
          if (err.data != null) {
            Message.showError(
              t("message.COMMON_MESSAGE." + err.data.Messages[0].Message)
            );
          } else {
            Message.showError(t("message.COMMON_MESSAGE.SEARCH_FAILURE"));
          }
        })
        .finally(() => {
          this.showFlag = false;
        });
    },

    //チェックボックスの選択処理
    checkedProcess() {
      if (this.tableData && this.transportProdForm) {
        this.tableData.forEach((row) => {
          for (let index = 0; index < this.transportProdForm.length; index++) {
            const element = this.transportProdForm[index];

            //詳細画面選択のデータ選択チェックボックス
            if (
              row.tdCReceNo == element.tdCReceNo &&
              row.tdCReceDetailNo == element.tdCReceDetailNo
            ) {
              this.$nextTick(() => {
                this.$refs.transportProdForm.toggleRowSelection(
                  this.transportProdForm[index],
                  true
                );
              });
            }
          }
        });
      }

      // 読み込み回数 = 1
      if (this.numLoads == 1) {
        let data = this.$refs.transportProdForm.selection;

        // 比較用明細情報
        this.cmpDetailResult = JSON.parse(JSON.stringify(data));

        // 読み込み回数 + 1
        this.numLoads = this.numLoads + 1;
      }
    },

    //検索条件の調整
    updateSearchForm() {
      if (this.dateRange) {
        this.searchConditionForm.searchStartDate = formatCurDateToString(
          this.dateRange[0]
        );
        this.searchConditionForm.searchEndDate = formatCurDateToString(
          this.dateRange[1]
        );
      }

      // ADD 2025/03/10 ZLL 課題_運送製品選択画面_検索条件と一覧列の追加 start↓
      else {
        // 入荷日の日付が空の場合、
        this.searchConditionForm.searchStartDate = STR_EMPTY;
        this.searchConditionForm.searchEndDate = STR_EMPTY;
      }

      if (this.cusDateRange) {
        this.searchConditionForm.searchStartCusDate = formatCurDateToString(
          this.cusDateRange[0]
        );
        this.searchConditionForm.searchEndCusDate = formatCurDateToString(
          this.cusDateRange[1]
        );
      } else {
        //得意先納期日付が空の場合、
        this.searchConditionForm.searchStartCusDate = STR_EMPTY;
        this.searchConditionForm.searchEndCusDate = STR_EMPTY;
      }
      // ADD 2025/03/10 ZLL 課題_運送製品選択画面_検索条件と一覧列の追加 end↑
    },

    //列幅に自動調整
    FlexColumnWidthFunc(label, prop) {
      return flexColumnWidth(label, prop, this.transportProdForm);
    },

    //确定ボタン
    ConfirmClick() {
      let data = this.$refs.transportProdForm.selection;

      if (!!data && data.length > 0) {
        var result = [
          { key: "selectedProcForm", value: data },
          { key: "searchConditionForm", value: this.searchConditionForm },
        ];
        this.$emit("ok", result);
      } else {
        Modal.showWarning("", t("message.COMMON_MESSAGE.PLEASE_SELECT_DATA"), {
          confirmButtonText: t("resource.COMMON_CONSTANT.CONFIRM"),
        });
      }
    },

    // 製品異常
    rowClassName({ row }) {
      if (!!row.tdProdExKbn && row.tdProdExKbn != "") {
        if (row.tdProdExKbn != NORMAL_PROD) {
          return "textColor";
        }
      }
    },

    // ダイアログを閉じる
    // onCancel() {
    //   if (
    //     !cmpDetailData(
    //       this.cmpDetailResult,
    //       this.$refs.transportProdForm.selection
    //     ) &&
    //     this.cmpDetailResult.length > 0
    //   ) {
    //     return new Promise((resolve, reject) => {
    //       Modal.showWarning(
    //         "",
    //         t("message.COMMON_MESSAGE.DATA_ALREADY_CHANGED_CLOSE"),
    //         {
    //           $type: "prompt",
    //           confirmButtonText: t("resource.button.sure"),
    //           cancelButtonText: t("resource.button.cancel"),
    //           showCancelButton: true,
    //         }
    //       )
    //         .then(() => {
    //           // 用户点击确认
    //           resolve(true);
    //         })
    //         .catch((error) => {
    //           // 用户点击取消或关闭对话框
    //           resolve(false);
    //         });
    //     });
    //   } else {
    //     return true;
    //   }
    // },

    // ダイアログを閉じる
    Close() {
      this.$emit("cancel");
    },
  },
};
</script>
<style scoped>
</style>
